module.exports = __webpack_public_path__ + "img/12.89856310.jpg";